module.exports = __webpack_public_path__ + "static/media/send-feedback-group.7e7531fa.svg";